import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import IconButton from './buttons/IconButton';
import { Tooltip } from './dataDisplay/Tooltip';

interface TableMagnifyingGlassIconProps {
  onClick?(): void;
  className?: string;
}

export default function TableMagnifyingGlassIcon(props: TableMagnifyingGlassIconProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'tableHeader',
  });

  const { onClick, className } = props;

  return (
    <Tooltip text={t('search')} className="font-400">
      <IconButton
        testId="searchIconButton"
        onClick={onClick}
        icon={
          <MagnifyingGlassIcon className={`w-4 h-4 ${className || 'text-base-100'}`} />
        }
      />
    </Tooltip>
  );
}
